import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "../overview.md"
      }}>{`@add-on-hlapi-sdk`}</a>{` / StrokeOptions`}</p>
    <h1 {...{
      "id": "interface-strokeoptions"
    }}>{`Interface: StrokeOptions`}</h1>
    <p>{`Properties that can be provided to create a stroke.`}</p>
    <h2 {...{
      "id": "hierarchy"
    }}>{`Hierarchy`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p"><inlineCode parentName="strong">{`StrokeOptions`}</inlineCode></strong></p>
        <p parentName="li">{`↳ `}<a parentName="p" {...{
            "href": "Stroke.md"
          }}><inlineCode parentName="a">{`Stroke`}</inlineCode></a></p>
      </li>
    </ul>
    <h2 {...{
      "id": "table-of-contents"
    }}>{`Table of contents`}</h2>
    <h3 {...{
      "id": "properties"
    }}>{`Properties`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "StrokeOptions.md#color"
        }}>{`color`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "StrokeOptions.md#dashOffset"
        }}>{`dashOffset`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "StrokeOptions.md#dashPattern"
        }}>{`dashPattern`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "StrokeOptions.md#width"
        }}>{`width`}</a></li>
    </ul>
    <h2 {...{
      "id": "properties-1"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "a-idcolor-namecolora-color"
    }}><a id="color" name="color"></a>{` color`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Readonly`}</inlineCode>{` `}<strong parentName="p">{`color`}</strong>{`: `}<a parentName="p" {...{
        "href": "../classes/Color.md"
      }}><inlineCode parentName="a">{`Color`}</inlineCode></a></p>
    <p>{`The color of a stroke.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-iddashoffset-namedashoffseta-dashoffset"
    }}><a id="dashOffset" name="dashOffset"></a>{` dashOffset`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Readonly`}</inlineCode>{` `}<strong parentName="p">{`dashOffset`}</strong>{`: `}<inlineCode parentName="p">{`number`}</inlineCode></p>
    <p>{`Number of pixels the beginning of dash pattern should be offset along the stroke.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-iddashpattern-namedashpatterna-dashpattern"
    }}><a id="dashPattern" name="dashPattern"></a>{` dashPattern`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Readonly`}</inlineCode>{` `}<strong parentName="p">{`dashPattern`}</strong>{`: `}<inlineCode parentName="p">{`number`}</inlineCode>{`[]`}</p>
    <p>{`If empty, this is a solid stroke.
If non-empty, the values alternate between length of a rendered and blank segment,
repeated along the length of the stroke. The first value represents the first solid segment.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idwidth-namewidtha-width"
    }}><a id="width" name="width"></a>{` width`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Readonly`}</inlineCode>{` `}<strong parentName="p">{`width`}</strong>{`: `}<inlineCode parentName="p">{`number`}</inlineCode></p>
    <p>{`The thickness of a stroke. Must be from MIN_STROKE_WIDTH to MAX_STROKE_WIDTH.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      